import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { ContainerOverview } from './styles';

interface ChartProps {
  data: any;
  categories: Array<number | string>;
  title: string;
}

export function OverviewChart({ data, categories, title }: ChartProps) {
  const options: ApexOptions = {
    chart: {
      type: 'line',
      toolbar: {
        show: false,
      },
      foreColor: '#6b6b6b6b',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    legend: {
      position: 'top',
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
      labels: {
        style: {
          fontSize: window.innerWidth < 1366 ? '7px' : '11px',
          fontWeight: 600,
        },
      },
    },
    grid: {
      show: true,
    },
    yaxis: {
      show: true,
      labels: {
        style: {
          fontSize: window.innerWidth < 1366 ? '7px' : '11px',
          fontWeight: 600,
        },
      },
    },
    fill: {
      colors: ['#b7cb21'],
    },
    tooltip: {
      y: [
        {
          title: {
            formatter: (val) => {
              return val;
            },
          },
        },
        {
          title: {
            formatter: (val) => {
              return val;
            },
          },
        },
      ],
    },
  };

  return (
    <ContainerOverview>
      <div>
        <h1>{title}</h1>
        <div>
          <label htmlFor="select">Filtrar por:</label>
          <select id="select">
            <option>Todos</option>
            <option>Whatsapp</option>
            <option>Portal</option>
          </select>
        </div>
      </div>
      {/* @ts-ignore*/}
      <ReactApexChart
        options={options}
        series={data}
        height="90%"
        width="100%"
      />
    </ContainerOverview>
  );
}
